<ng-container *ngIf="initialized">
  <form class="form" (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="!instructorId" class="modal-title" id="exampleModalLabel">Add {{ personType }}</h5>
        <h5 *ngIf="instructorId" class="modal-title" id="exampleModalLabel">Edit {{ personType }}</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="exampleFormControlInput1">Email</label>
              <input type="text" class="form-control" [readonly]="this.instructorId" formControlName="email" />
              <div class="invalid-message">
                <div>Email is required</div>
              </div>
            </div>
            <div class="form-group pl-8 pr-8" *ngIf="userExists">
              <p class="text-center">
                Hold the phone! It looks like a user with the email address <Strong>{{ formGroup.controls.email.value }}</Strong> already exists in the system.
              </p>
              <div class="row">
                <div class="col-md-3">
                  <img class="img-fluid rounded-circle"  [fallback]="'fetch-avatar?userId=' + existingUser.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ existingUser.id }}-avatar.png" />
                </div>
                <div class="col-md-9">
                  <div>{{ existingUser.firstName }} {{ existingUser.lastName }}, {{ existingUser.credentials }}</div>
                  <button class="btn btn-sm btn-secondary mr-2" [promiseBtn]="submitComplete" (click)="linkExistingUser()" type="button">Link</button>
                </div>
              </div>
            </div>
            <div class="contextual-overlay-container">
              <div class="contextual-overlay-content" [ngClass]="{ show: !formGroup.controls.email.valid || userExists }">
                <div *ngIf="!formGroup.controls.email.valid">Start by entering the {{ personType }}'s email</div>
              </div>
              <div class="contextual-overlay" [ngClass]="{ show: !formGroup.controls.email.valid || userExists }"></div>
              <div class="form-group">
                <label for="exampleFormControlInput1">First Name</label>
                <input type="text" class="form-control" [readonly]="this.instructorId" formControlName="firstName" />
                <div class="invalid-message">
                  <div>First Name is required</div>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleFormControlInput1">Last Name</label>
                <input type="text" class="form-control" [readonly]="this.instructorId" formControlName="lastName" />
                <div class="invalid-message">
                  <div>Last Name is required</div>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleFormControlInput1">Pronouns (Public) <span class="text-muted">(optional)</span></label>
                <input type="text" class="form-control" formControlName="pronouns" />
              </div>
              <div class="form-group">
                <label for="exampleFormControlInput1">Gender Identity <span class="text-muted">(optional)</span></label>
                <select id="inputState" class="form-control" formControlName="genderIdentity">
                  <option [ngValue]="null" selected>Choose...</option>
                  <option [value]="'Cisgender Female'">Cisgender Female</option>
                  <option [value]="'Cisgender Male'">Cisgender Male</option>
                  <option [value]="'Nonbinary'">Nonbinary</option>
                  <option [value]="'Gender-Fluid'">Gender-Fluid</option>
                  <option [value]="'Transgender'">Transgender</option>
                  <option [value]="'SELF'">Prefer to Self-Describe</option>
                </select>
                <input *ngIf="formGroup.controls.genderIdentity.value != null && formGroup.controls.genderIdentity.value != 'Cisgender Female' && formGroup.controls.genderIdentity.value != 'Cisgender Male' && formGroup.controls.genderIdentity.value != 'Nonbinary' && formGroup.controls.genderIdentity.value != 'Gender-Fluid' && formGroup.controls.genderIdentity.value != 'Transgender'" type="text" formControlName="genderIdentityText" class="form-control mt-1" />
              </div>
              <div class="form-group">
                <label for="exampleFormControlInput1">Race/Ethnicity <span class="text-muted">(optional)</span></label>
                <select id="inputState" class="form-control" formControlName="raceEthnicity">
                  <option [ngValue]="null" selected>Choose...</option>
                  <option [value]="'American Indian or Alaska Native'">American Indian or Alaska Native</option>
                  <option [value]="'Asian or Asian American'">Asian or Asian American</option>
                  <option [value]="'Black or African American'">Black or African American</option>
                  <option [value]="'Hispanic or Latino'">Hispanic or Latino</option>
                  <option [value]="'Middle Eastern or North African'">Middle Eastern or North African</option>
                  <option [value]="'Native Hawaiian or Pacific Islander'">Native Hawaiian or Pacific Islander</option>
                  <option [value]="'White'">White</option>
                  <option [value]="'SELF'">Another race or ethnicity not listed above</option>
                </select>
                <input *ngIf="formGroup.controls.raceEthnicity.value != null && formGroup.controls.raceEthnicity.value != 'American Indian or Alaska Native' && formGroup.controls.raceEthnicity.value != 'Asian or Asian American' && formGroup.controls.raceEthnicity.value != 'Black or African American' && formGroup.controls.raceEthnicity.value != 'Hispanic or Latino' && formGroup.controls.raceEthnicity.value != 'Middle Eastern or North African' && formGroup.controls.raceEthnicity.value != 'Native Hawaiian or Pacific Islander' && formGroup.controls.raceEthnicity.value != 'White'" type="text" formControlName="raceEthnicityText" class="form-control mt-1" />
              </div>
              <div class="form-group">
                <label for="exampleFormControlInput1">Credentials</label>
                <input type="text" class="form-control" formControlName="credentials" />
              </div>
              <div class="form-group" *ngIf="conferenceId != 324 ">
                <label for="exampleFormControlInput1">Is User a BCBA/BCBA-D f{{conferenceId}}</label>
                <select id="inputState" class="form-control" formControlName="isBCBA">
                  <option [ngValue]="null" selected>Choose...</option>
                  <option [value]="true">Yes</option>
                  <option [value]="false">No</option>
                </select>
                <div class="invalid-message">
                  <div>BCBA is required</div>
                </div>
              </div>
              <div class="form-group">
                <label for="firstName">Certification Number <span class="text-muted"></span></label>
                <input type="text" formControlName="certificantNumber" class="form-control" />
              </div>
              <div class="form-group">
                <label for="firstName">Affiliation <span class="text-muted"></span></label>
                <input type="text" formControlName="affiliation" class="form-control" />
              </div>
              <div class="form-group">
                <label for="firstName">Organizational Title <span class="text-muted"></span></label>
                <input type="text" formControlName="organizationalTitle" class="form-control" />
              </div>
              <div class="form-group">
                <label for="firstName">Phone Number <span class="text-muted"></span></label>
                <input type="text" formControlName="phoneNumber" class="form-control" />
              </div>



              <div class="form-group">
                <label for="exampleFormControlInput1" class="d-block">Biography</label>
                <a *ngIf="!textEditMode" href="javascript:void(0)" (click)="textEditMode = true">Switch to Plain Text</a>
                <a *ngIf="textEditMode" href="javascript:void(0)" (click)="textEditMode = false">Switch to Rich Text</a>
                <textarea *ngIf="textEditMode" style="height: 200px" formControlName="biography" class="form-control"></textarea>
                <kendo-editor *ngIf="!textEditMode" formControlName="biography"></kendo-editor>
              </div>
              <div class="form-group">
                <div class="media align-items-center mb-7">
                  <div class="u-lg-avatar mr-3">
                    <span *ngIf="!avatar" class="btn btn-lg btn-icon btn-dark rounded-circle mr-3">
                      <span class="btn-icon__inner">S</span>
                    </span>
                    <img *ngIf="avatar" class="img-fluid rounded-circle" style="max-width: 400px" src="/fetchimage?fileName={{ avatar }}&height=100&width=100&mode=Crop" />
                  </div>

                  <div class="media-body">
                    <kendo-upload class="ml-5" [saveUrl]="uploadUrl" [multiple]="false" (success)="successEventHandler($event)"></kendo-upload>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button *ngIf="!userExists" class="btn btn-sm btn-secondary mr-2" [promiseBtn]="submitComplete" type="submit">
              <span *ngIf="!instructorId">Add {{ personType }}</span>
              <span *ngIf="instructorId">Update {{ personType }}</span>
            </button>
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
